module.exports = __webpack_public_path__ + "static/media/160421-GlobalNavIA_v5.012.32d09554.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160421-GlobalNavIA_v5/160421-GlobalNavIA_v5.012.png
// module id = 206
// module chunks = 0